/** Faixa vertical de um bloco que não pode ser cortado, em pixels da imagem. */
export interface FaixaInteira {
  topo: number;
  base: number;
}

/**
 * Onde cortar a página que começa em `inicio` e cabe até `limite`.
 *
 * O PDF é uma captura de tela fatiada, e `page-break-inside: avoid` só vale na
 * impressão do navegador — a captura ignora. Cortar em altura fixa partia ao
 * meio o que estivesse ali; com descrições longas era a barra do TOTAL GERAL,
 * metade em cada página.
 *
 * Se o corte cai dentro de um bloco inteiro, ele sobe para logo antes do bloco,
 * e repete, porque o novo ponto pode cair dentro de outro bloco (a linha dentro
 * da tabela, por exemplo). Bloco mais alto que uma página não tem como ficar
 * inteiro e é ignorado — senão o corte subiria até o começo da página e nada
 * caberia. Sem ponto seguro, corta no limite, como antes.
 */
export function escolherCorte(
  inicio: number,
  limite: number,
  faixas: FaixaInteira[],
): number {
  const capacidade = limite - inicio;
  const evitaveis = faixas.filter(
    (f) => f.base - f.topo > 0 && f.base - f.topo <= capacidade,
  );

  let corte = limite;
  for (let i = 0; i <= evitaveis.length; i++) {
    const cortado = evitaveis.find((f) => f.topo < corte && corte < f.base);
    if (!cortado) return corte;
    corte = cortado.topo;
    if (corte <= inicio) return limite;
  }
  return limite;
}
